import { Component, NgModule, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Advertiser, AffiliateNetworkAdvertisers } from '_models/affiliate-network-advertisers-data';
import { LessPennyService } from '_services/lesspenny.service';
import { ModalDismissReasons, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EditAdvertiserModalComponent } from '../edit-advertiser-modal/edit-advertiser-modal.component';
import { ReturnResponse } from '_models/api-return-response';

@Component({
  selector: 'app-advertisers',
  templateUrl: './advertisers.component.html',
  styleUrls: ['./advertisers.component.css']
})
export class AdvertisersComponent implements OnInit {

  constructor(private lesspennyService: LessPennyService, private modalService: NgbModal) { }

  dataObs$: Observable<AffiliateNetworkAdvertisers>;
  //closeResult: string;
  apiRes: ReturnResponse;
  advUpdatedMsg: string;

  ngOnInit() {
    this.dataObs$ = this.lesspennyService.getAffiliateNetworksAdvertisers();
    console.log('data= ' + this.dataObs$);
  }

  openModal(adv) {
    const modalRef = this.modalService.open(EditAdvertiserModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.advertiser = adv;

    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.UpdateAdvertiser(receivedEntry);
    })

    ////check how modal is closed. don't know how to leverage?
    // modalRef.result
    //   .then((result) => {
    //     this.closeResult = `Closed with: ${result}`;
    //     console.log(this.closeResult);
    //   }, (reason) => {
    //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //     console.log(this.closeResult);
    //   });
  }

  private UpdateAdvertiser(editedAdv: Advertiser) {
    console.log('on update=');
    console.log(editedAdv);
    this.lesspennyService.updateAffiliateNetworksAdvertisers(editedAdv)
      .subscribe(res => {    //you need to subscribe to get data out of observable
        this.apiRes = res;
        let returnMsg = this.apiRes.ReturnMessage;
        this.advUpdatedMsg = (returnMsg === undefined) ? `Something went wrong while updating ${editedAdv.AdvertiserName}.` : returnMsg;
        console.log('Response=' + this.apiRes.IsSuccess + ', message=' + this.apiRes.ReturnMessage)
      });
    //console.log('Resp= ' + resp);
  }

  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return `with: ${reason}`;
  //   }
  // }

}
